var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Page"},[_c('div',{staticClass:"location Page-Content"},[_c('div',{staticClass:"location-img"},[_c('img',{attrs:{"ondragstart":"return false;","src":require("@/assets/172-img/map.png"),"alt":""}})])])])
}]

export { render, staticRenderFns }